import { cn } from '../../utils/cn';

/** `.pen` `ds/form/field-group--default`. */
export function QuickCreateFieldGroup({
  label,
  optional,
  value,
  onChange,
  placeholder,
  hint,
  type = 'text',
  className,
  inputProps,
}) {
  return (
    <div className={cn('flex w-full flex-col gap-space-2', className)}>
      <div className="flex w-full items-center justify-between">
        <span className="type-label text-foreground">{label}</span>
        {optional ? <span className="type-body-sm font-normal text-muted-foreground">{optional}</span> : null}
      </div>
      <div className="flex w-full items-center rounded-ds-md border border-border bg-card px-space-4 py-space-3">
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="type-body min-w-0 flex-1 border-0 bg-transparent text-card-foreground outline-none placeholder:text-muted-foreground"
          {...inputProps}
        />
      </div>
      {hint ? <p className="type-body-sm font-normal text-muted-foreground">{hint}</p> : null}
    </div>
  );
}
